import { Box, Flex, Skeleton, Text, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import 'borrower/borrower.scss';
import { RouteTemplate } from 'packages/common-frontend/components/RouteTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { AssignmentEditByCSVContainer } from 'packages/loanProduct/ui/AssignmentEditByCSVContainer';
import { AssignmentHeader } from 'packages/loanProduct/ui/AssignmentTemplate';

export const AssignmentEditByCSVRoute = () => {
  const toast = useToast();
  const history = useHistory();

  let routeLevelError = false;

  const { data: userData, loading: userLoading } = useGetUserQuery();

  if (!userData || !userData.user || userLoading) {
    return <Skeleton />;
  }
  const {
    user: { organizationId },
  } = userData;

  return (
    <RouteTemplate>
      <Box className="main">
        <Sentry.ErrorBoundary
          onError={() => {
            if (!routeLevelError && !toast.isActive(errorToastId)) {
              errorToastConfig.title = `Failed to load assignment edit by csv route`;
              routeLevelError = true;
              toast(errorToastConfig);
              history.push('/');
            }
          }}
        >
          <Flex width="1250px" direction="column">
            <Flex justify="space-between" mb="24px">
              <AssignmentHeader editMode />
            </Flex>
            <Text fontSize="lg" mb="4px">
              To assign receivables, upload .CSV files to the relevant loan
              product & credit facility grouping(s) below. .CSVs should only
              contain receivable IDs.
            </Text>
            <Text fontSize="lg" mb="32px">
              Assigning by .CSV will reset any prior assignment proposals from
              assign by strategy and/or assign by individual receivable.
            </Text>
          </Flex>
          <AssignmentEditByCSVContainer organizationId={organizationId} />
        </Sentry.ErrorBoundary>
      </Box>
    </RouteTemplate>
  );
};
